import { render } from "./Terminar.vue?vue&type=template&id=7838cafe"
import script from "./Terminar.vue?vue&type=script&lang=js"
export * from "./Terminar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__